import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_ICON_SIZE = { w: 44, h: 24 };

function SbpIcon({ className, w, h }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w || DEFAULT_ICON_SIZE.w}
      height={h || DEFAULT_ICON_SIZE.h}
      viewBox="0 0 44 24"
      className={className}
    >
      <g fillRule="nonzero" fill="none">
        <path
          d="M37.714 8.928v6.192h2.143v-4.368h2.048v4.368H44V8.928h-6.286zm-4-.336h1.953l1-1.824h-3.143c-2.286.048-3.81 2.016-3.81 4.464 0 2.88 1.62 4.032 3.572 4.032 2 0 3.476-1.296 3.428-3.072-.047-1.392-1.19-2.736-2.714-2.736-.857 0-1.667.288-2.19.816.047-1.008.904-1.68 1.904-1.68zm-.524 2.448c.762 0 1.286.624 1.286 1.344 0 .72-.571 1.296-1.333 1.296-.572 0-1.238-.528-1.238-1.296 0-.72.571-1.344 1.285-1.344zm-6.857-.48c.905-.048 1.667.48 1.667.48l.81-1.44c-.715-.528-1.429-.816-2.381-.816-2.096 0-3.572 1.728-3.572 3.216 0 1.776 1.572 3.264 3.524 3.264.857 0 1.714-.288 2.38-.816L28 12.96s-.714.48-1.667.48c-.619 0-1.428-.528-1.428-1.44 0-.912.81-1.44 1.428-1.44z"
          fill="#1B0A40"
        />
        <path fill="#874691" d="m5.952 12-3.095 1.824L0 18.864 11.762 12z" />
        <path fill="#DA1844" d="M14.857 6.816 11.762 8.64l-2.905 5.04L20.62 6.816z" />
        <path fill="#F9B229" d="M11.762 5.04 8.857 0v24l2.905-5.04z" />
        <path fill="#F07F1A" d="m8.857 0 2.905 5.04 3.095 1.776h5.81z" />
        <path fill="#72B22C" d="M8.857 10.32V24l2.905-5.04v-3.6z" />
        <path fill="#00743E" d="m14.857 17.184-3.095 1.776L8.857 24l11.762-6.816z" />
        <path fill="#5F5A94" d="M0 5.184v13.68l2.905-5.04v-3.648z" />
        <path fill="#0D90CD" d="M8.857 10.32 0 5.184l2.905 4.992 11.952 7.008h5.81z" />
      </g>
    </svg>
  );
}

SbpIcon.ICON_SIZE = DEFAULT_ICON_SIZE;

SbpIcon.propTypes = {
  w: PropTypes.number,
  h: PropTypes.number,
  className: PropTypes.string,
};

SbpIcon.defaultProps = {
  className: '',
};

export default SbpIcon;
